module.exports = __webpack_public_path__ + "img/6_83.0f6c3ab8.png";